var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#D11116"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_362_2103)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.982,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5859 36.6035C55.2213 36.5905 44.8567 36.6035 34.4922 36.6426C33.9497 36.6803 33.4548 36.8496 33.0078 37.1504C37.995 40.8219 42.995 44.4807 48.0078 48.127C49.362 49.1166 50.7162 49.1166 52.0703 48.127C57.0831 44.4807 62.0831 40.8219 67.0703 37.1504C66.6073 36.8597 66.1126 36.6774 65.5859 36.6035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.988,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1328 40.3545C31.0287 43.5702 30.9766 46.8124 30.9766 50.0811C30.9896 53.3232 31.0026 56.5654 31.0156 59.8076C31.3505 61.8353 32.5355 62.9941 34.5703 63.2842C44.8828 63.3363 55.1953 63.3363 65.5078 63.2842C67.5426 62.9941 68.7275 61.8353 69.0625 59.8076C69.1016 53.3493 69.1146 46.891 69.1016 40.4326C68.9603 40.4319 68.8301 40.471 68.7109 40.5498C63.0339 44.6904 57.3568 48.8311 51.6797 52.9717C50.5859 53.6488 49.4922 53.6488 48.3984 52.9717C42.629 48.7766 36.8738 44.5709 31.1328 40.3545Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_362_2103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(30 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageRed);
export default __webpack_public_path__ + "static/media/MessageRed.b68067d93a03f18ea7488b6eacf4effe.svg";
export { ForwardRef as ReactComponent };